const validateZipCode = (zipCode: string): boolean => /^\d{5}$/.test(zipCode);

export default validateZipCode;
